import { render, staticRenderFns } from "./AccessBtnAdd.vue?vue&type=template&id=2cf4bcf3&scoped=true&"
import script from "./AccessBtnAdd.vue?vue&type=script&lang=js&"
export * from "./AccessBtnAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccessBtnAdd.vue?vue&type=style&index=0&id=2cf4bcf3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4bcf3",
  null
  
)

export default component.exports